import {OverlayModule} from '@angular/cdk/overlay';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NotifierModule} from 'angular-notifier';
import {CookieModule} from 'ngx-cookie';

import {NOTIFIER_OPTIONS} from '@shared/constants/notifier.constant';
import {MaterialModule} from '@shared/material.module';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  imports: [
    // Base Angular & forms modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    // Third-party libs / material
    CookieModule.forRoot(),
    NotifierModule.withConfig(NOTIFIER_OPTIONS),
    FlexLayoutModule,
    MaterialModule,
    MatIconModule,
  ],
  exports: [
    FormsModule,
    CommonModule,
    NotifierModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialModule,
    OverlayModule,
    MatIconModule,
  ],
})
export class SharedLibsModule {}
